// app/javascript/controllers/image_carousel_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "indicator"]

  connect() {
    this.showSlide(0)
  }

  next() {
    this.showSlide((this.index + 1) % this.slideTargets.length)
  }

  prev() {
    this.showSlide((this.index - 1 + this.slideTargets.length) % this.slideTargets.length)
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, i) => {
      slide.classList.toggle('hidden', i !== index)
      this.indicatorTargets[i].classList.toggle('bg-white', i === index)
      this.indicatorTargets[i].classList.toggle('bg-gray-400', i !== index)
    })
    this.index = index
  }

  get index() {
    return parseInt(this.data.get('index') || 0)
  }

  set index(value) {
    this.data.set('index', value)
  }
}